<div style="display: flex; align-items: flex-start; flex-direction: column; width: 100%; height: 100%; background: #fff; padding: 15px; gap: 15px;">
    <h3>Conversor de Ruta</h3>
    <input type="file" accept=".json" (change)="onFileSelected($event)" />
    @if(finalData()){
        <button (click)="downloadJSON()" style="border: 1px solid #aaa; padding: 5px 10px; border-radius: 5px;">GET INFO</button>
    }
</div>